import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteDocs = (caseId: string, onComplete: () => void) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const deleteDocs = async (docIds: string[]) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.DELETE,
      data: {
        docIds,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/docs`, fetchConfig);
    if (!response.ok) {
      throw new Error('Deleting docs failed');
    }
  };

  return useMutation({
    mutationFn: (docIds: string[]) => deleteDocs(docIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Case] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseDocs] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseFacts] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseInconsistencies] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseOverview] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Doc] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocIds] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocTotals] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Fact] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.InconsistencyReport] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.KeyFacts] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Messages] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Summary] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Threads] });

      onComplete();
    },
  });
};
